import { CartRepository } from '@lib/api/repository/cart/cart.repository';
import { CartBatchResult, CartItemInput, CartRecord } from '@lib/types';
import { CartProductItem } from '@lib/types/cart';

import { Requester } from '../clients';
import { ProductOfferDTO, createProductOffer } from '../products';

export default class CartAPI implements CartRepository {
  async listProducts(signal?: AbortSignal): Promise<CartProductItem[]> {
    const { data } = await Requester.get<
      Array<{
        id: string;
        quantity: number;
        offer: ProductOfferDTO;
        store: CartProductItem['store'];
      }>
    >('/marketplace/cart/products', { signal });
    return data.map((item) => ({
      id: item.id,
      quantity: item.quantity,
      store: item.store,
      offer: createProductOffer(item.offer),
    }));
  }

  async addProduct(productOfferId: string, quantity: number) {
    await Requester.post('/marketplace/cart/products', {
      body: { productOfferId, quantity },
    });
  }

  async updateProduct(id: string, quantity: number) {
    await Requester.patch(`/marketplace/cart/products/${id}`, {
      body: { quantity },
    });
  }

  async removeProduct(id: string) {
    await Requester.delete(`/marketplace/cart/products/${id}`);
  }

  async list(signal?: AbortSignal) {
    const response = await Requester.get<CartRecord[]>('/marketplace/cart', {
      signal,
    });
    return response.data;
  }

  async add(input: CartItemInput) {
    return (
      await Requester.post<CartRecord>('/marketplace/cart/items', {
        body: input,
      })
    ).data;
  }

  async addBatch(items: CartItemInput[], idempotencyKey: string) {
    return (
      await Requester.post<CartBatchResult>('/marketplace/cart/items/batch', {
        body: { idempotencyKey, items },
      })
    ).data;
  }

  async import(items: CartItemInput[]) {
    return (
      await Requester.post<CartRecord[]>('/marketplace/cart/import', {
        body: { items },
      })
    ).data;
  }

  async update(id: string, quantity: number) {
    return (
      await Requester.patch<CartRecord>(`/marketplace/cart/items/${id}`, {
        body: { quantity },
      })
    ).data;
  }

  async remove(id: string) {
    await Requester.delete(`/marketplace/cart/items/${id}`);
  }

  async clearStore(storeId: string) {
    await Requester.delete(`/marketplace/cart/stores/${storeId}`);
  }
}
